<h3 class="with-manual-link">
  <span i18n="@@bot-task">Bot-Aufgabe</span>
  <app-manual-link href="/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Bot-Aufgabe"></app-manual-link>
</h3>
<p
  class="text-secondary mt-1 mb-1"
  i18n="@@bot-task-callout"
>Lege fest, welche Rolle und Aufgaben dein Bot übernehmen soll.</p>
<!-- das ist eine besonders gute zeile -->
<div class="row mt-3">
  <div class="col-3">

    <span i18n="@@bot-instructions">Bot-Instruktionen</span>
    <app-hint i18n="@@bot-instructions-hint">
      Hier kannst du <b>Instruktionen</b> zur Funktion/Aufgabe des Bots verfassen.
    </app-hint>
    <br>
    <a
      id="botlyFragenButton"
      class="text-decoration-none"
      [class.cursor-pointer]="!isBotlyLoading"
      [class.text-muted]="isBotlyLoading"
      (click)="this.openBotly()"
    >
      @if (isBotlyLoading) {
      <i class="botly me-1 botly-pulse"></i>
      <span i18n="@@botly-loading">Botly bereitet sich vor…</span>
      } @else {
      <i class="botly me-1"></i>
      <span i18n="@@ask-botly">Botly Fragen</span>
      }
    </a>
  </div>
  <div class="col">
    <app-codemirror-ai
      [placeholder]="this.botInstruction"
      [instruction]="this.rss.botConfig.botInstruction"
      [rows]="13"
      (finish)="this.rss.botConfig.botInstruction = $event; this.rss.saveBotConfigField('botInstruction')"
    ></app-codemirror-ai>
  </div>
</div>

@if (this.loginService.hasSUPERAdmin()) {
<div class="row mt-5">
  <div class="col-3">
    <span i18n="@@is-template-provide">Als Vorlage bereitstellen</span>
  </div>
  <div class="col">
    <p-toggleswitch
      [(ngModel)]="this.rss.botConfig.isTemplate"
      (ngModelChange)="this.onTemplateToggle($event)"
    >
      <ng-template
        #handle
        let-checked="checked"
      >
        <i [ngClass]="['!text-xs', 'ri', checked ? 'ri-check-line' : 'ri-close-line']"></i>
      </ng-template>
    </p-toggleswitch>
  </div>
</div>
}

@if (this.rss.botConfig.isTemplate) {
<div
  class="mt-5 p-1 border-round-lg surface-50 border-1 surface-border"
  style="background-color:whitesmoke;"
>

  <div class="row">
    <div class="col">
      <h5
        i18n="@@template-configuration"
        class="mb-0"
      ><i class="ri-layout-grid-line me-2"></i>Vorlagen-Konfiguration</h5>
      <p
        class="text-secondary mt-1 mb-0"
        i18n="@@template-configuration-hint"
      >Konfiguriere hier die Einstellungen für diese Vorlage.</p>
    </div>
  </div>

  @if (this.loginService.hasSUPERAdmin()) {
  <div class="card border-0 mb-4 mt-4">
    <div class="card-body">
      <div class="row">
        <div class="col-3">
          <span i18n="@@template-description-label">Vorlagen-Beschreibung</span>
          <app-hint i18n="@@template-description-hint">
            Diese Beschreibung wird Benutzern beim Erstellen eines Bots aus dieser Vorlage angezeigt. Sie kann Markdown
            verwenden.
          </app-hint>
        </div>
        <div class="col">
          <app-codemirror-ai
            [placeholder]="'Beschreibe deine Vorlage...'"
            [instruction]="this.rss.botConfig.templateDescription || ''"
            [rows]="6"
            (finish)="this.rss.botConfig.templateDescription = $event; this.rss.saveBotConfigField('templateDescription')"
          ></app-codemirror-ai>
        </div>
      </div>
      <div class="row mt-3 align-items-center">
        <div class="col-3">
          <span i18n="@@is-template-draft">Entwurf</span>
          <app-hint i18n="@@is-template-draft-hint">
            Solange diese Vorlage als Entwurf markiert ist, wird sie nicht in der Vorlagenauswahl beim Erstellen eines
            neuen Bots angezeigt.
          </app-hint>
        </div>
        <div class="col">
          <p-toggleswitch
            [(ngModel)]="this.rss.botConfig.isTemplateDraft"
            (ngModelChange)="this.onTemplateDraftToggle($event)"
          >
            <ng-template
              #handle
              let-checked="checked"
            >
              <i [ngClass]="['!text-xs', 'ri', checked ? 'ri-check-line' : 'ri-close-line']"></i>
            </ng-template>
          </p-toggleswitch>
        </div>
      </div>
    </div>
  </div>
  }



  <div class="card border-0">
    <div class="card-body">
      <div class="row mt-3">
        <div class="col">
          <p-table
            [value]="this.rss.botConfig.templateVars || []"
            (onRowReorder)="this.onTemplateVarRowReorder($event)"
          >
            <ng-template #header>
              <tr>
                <th style="width: 2.5rem;"></th>
                <th
                  i18n="@@name"
                  style="width: 16%;"
                >Name</th>
                <th i18n="@@description">Beschreibung</th>
                <th
                  i18n="@@type"
                  style="width: 12%;"
                >Typ</th>
                <th i18n="@@default-value">Standardwert</th>
                <th i18n="@@properties-column">Eigenschaften</th>
                <th style="width: 56px;"></th>
              </tr>
            </ng-template>
            <ng-template
              #body
              let-tv
              let-i="rowIndex"
            >
              <tr
                style="vertical-align: top;"
                [pReorderableRow]="i"
              >
                <td>
                  <i
                    class="ri-draggable"
                    pReorderableRowHandle
                  ></i>
                </td>
                <td style="width: 16%;">
                  <input
                    pInputText
                    type="text"
                    class="w-100"
                    [(ngModel)]="tv.name"
                    [ngModelOptions]="{updateOn: 'blur'}"
                    (ngModelChange)="this.saveTemplateVars()"
                  >
                </td>
                <td>
                  <input
                    pInputText
                    type="text"
                    class="w-100"
                    [(ngModel)]="tv.description"
                    [ngModelOptions]="{updateOn: 'blur'}"
                    (ngModelChange)="this.saveTemplateVars()"
                  >
                </td>
                <td style="width: 12%;">
                  <p-select
                    [options]="this.templateVarTypes"
                    class="w-100"
                    appendTo="body"
                    optionLabel="label"
                    optionValue="value"
                    [(ngModel)]="tv.type"
                    (onChange)="this.onTemplateVarTypeChange(tv, i)"
                  ></p-select>
                </td>
                <td>
                  @if (tv.type === 'string') {
                  <div class="d-flex flex-column gap-2">
                    <textarea
                      pInputTextarea
                      class="w-100"
                      rows="3"
                      [(ngModel)]="tv.value"
                      [ngModelOptions]="{updateOn: 'blur'}"
                      (ngModelChange)="this.saveTemplateVars()"
                    ></textarea>
                    <p-button
                      icon="ri-code-s-slash-line"
                      label="Im HTML-Editor öffnen"
                      i18n-label="@@open-in-html-editor"
                      severity="secondary"
                      [text]="true"
                      [outlined]="true"
                      size="small"
                      styleClass="align-self-start"
                      (onClick)="this.openTemplateVarHtmlEditor(i)"
                    ></p-button>
                  </div>
                  }
                  @if (tv.type === 'number') {
                  <input
                    pInputText
                    type="number"
                    class="w-100"
                    [(ngModel)]="tv.value"
                    [ngModelOptions]="{updateOn: 'blur'}"
                    (ngModelChange)="this.saveTemplateVars()"
                  >
                  }
                  @if (tv.type === 'boolean') {
                  <p-toggleSwitch
                    [(ngModel)]="tv.value"
                    (onChange)="this.saveTemplateVars()"
                  ></p-toggleSwitch>
                  }
                </td>
                <td>
                  <div class="d-flex flex-column gap-2">
                    <div class="d-flex align-items-center gap-2">
                      <p-toggleSwitch
                        [ngModel]="this.isShowInWizardEnabled(tv)"
                        (onChange)="this.toggleShowInWizard(tv)"
                      ></p-toggleSwitch>
                      <span
                        class="text-sm"
                        i18n="@@property-show-in-wizard"
                      >Im Wizard abfragen</span>
                    </div>
                    @if (tv.type === 'string') {
                    <div class="d-flex align-items-center gap-2">
                      <p-toggleSwitch
                        [ngModel]="this.isAiVariableEnabled(tv)"
                        (onChange)="this.toggleAiVariable(tv)"
                      ></p-toggleSwitch>
                      <span
                        class="text-sm"
                        i18n="@@property-ai-rewrite"
                      >Eingabe mit KI überarbeiten</span>
                    </div>
                    }
                    @if (this.rss.botConfig.isTemplate) {
                    <div class="d-flex align-items-center gap-2">
                      <p-toggleSwitch
                        [ngModel]="!this.isDeleteAfterTemplateUsageEnabled(tv)"
                        (onChange)="this.toggleDeleteAfterTemplateUsage(tv)"
                      ></p-toggleSwitch>
                      <span
                        class="text-sm"
                        i18n="@@property-keep-in-final-bot"
                      >Im finalen Bot weiterhin anbieten</span>
                    </div>
                    }
                  </div>
                </td>
                <td style="width: 56px;">
                  <p-button
                    icon="ri-delete-bin-line"
                    severity="danger"
                    [text]="true"
                    (onClick)="this.removeTemplateVar(i)"
                  ></p-button>
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td
                  colspan="7"
                  class="text-center"
                  i18n="@@no-template-vars"
                >Keine Inhaltsvariablen definiert.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <p-button
            icon="ri-add-line"
            [label]="'Hinzufügen'"
            severity="secondary"
            [outlined]="true"
            (onClick)="this.addTemplateVar()"
            i18n-label="@@add"
          ></p-button>
        </div>
      </div>

      <p-dialog
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '75vw', maxWidth: '1100px' }"
        header="HTML-Editor"
        [(visible)]="this.isTemplateVarHtmlEditorVisible"
        (onHide)="this.closeTemplateVarHtmlEditor()"
      >
        <app-codemirror-html
          [code]="this.templateVarHtmlEditorValue"
          [rows]="20"
          (finish)="this.onTemplateVarHtmlEditorChange($event)"
        ></app-codemirror-html>

        <ng-template pTemplate="footer">
          <p-button
            label="Abbrechen"
            severity="secondary"
            [text]="true"
            (onClick)="this.closeTemplateVarHtmlEditor()"
          ></p-button>
          <p-button
            label="Speichern"
            (onClick)="this.saveTemplateVarHtmlEditor()"
          ></p-button>
        </ng-template>
      </p-dialog>
    </div>
  </div>

</div>
}

@if (!this.rss.botConfig.isTemplate && this.rss.botConfig.templateVars.length) {
<div class="mt-5">
  <h5 i18n="@@template-vars-heading"><i class="ri-list-settings-line me-2"></i>Inhaltsvariablen</h5>
  <p-table [value]="this.rss.botConfig.templateVars">
    <ng-template #header>
      <tr>
        <th
          i18n="@@name"
          style="width: 20%;"
        >Name</th>
        <th
          i18n="@@description"
          style="width: 30%;"
        >Beschreibung</th>
        <th i18n="@@value-column">Wert</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-tv
      let-i="rowIndex"
    >
      <tr style="vertical-align: top;">
        <td style="width: 20%;">{{tv.name}}</td>
        <td style="width: 30%;">{{tv.description}}</td>
        <td>
          @if (tv.type === 'string') {
          <div class="d-flex flex-column gap-2">
            <textarea
              pInputTextarea
              class="w-100"
              rows="3"
              [(ngModel)]="tv.value"
              [ngModelOptions]="{updateOn: 'blur'}"
              (ngModelChange)="this.saveTemplateVars()"
            ></textarea>
            <p-button
              icon="ri-code-s-slash-line"
              label="Im HTML-Editor öffnen"
              i18n-label="@@open-in-html-editor"
              severity="secondary"
              [text]="true"
              [outlined]="true"
              size="small"
              styleClass="align-self-start"
              (onClick)="this.openTemplateVarHtmlEditor(i)"
            ></p-button>
          </div>
          }
          @if (tv.type === 'number') {
          <input
            pInputText
            type="number"
            class="w-100"
            [(ngModel)]="tv.value"
            [ngModelOptions]="{updateOn: 'blur'}"
            (ngModelChange)="this.saveTemplateVars()"
          >
          }
          @if (tv.type === 'boolean') {
          <p-toggleSwitch
            [(ngModel)]="tv.value"
            (onChange)="this.saveTemplateVars()"
          ></p-toggleSwitch>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '75vw', maxWidth: '1100px' }"
    header="HTML-Editor"
    [(visible)]="this.isTemplateVarHtmlEditorVisible"
    (onHide)="this.closeTemplateVarHtmlEditor()"
  >
    <app-codemirror-html
      [code]="this.templateVarHtmlEditorValue"
      [rows]="20"
      (finish)="this.onTemplateVarHtmlEditorChange($event)"
    ></app-codemirror-html>

    <ng-template pTemplate="footer">
      <p-button
        label="Abbrechen"
        severity="secondary"
        [text]="true"
        (onClick)="this.closeTemplateVarHtmlEditor()"
      ></p-button>
      <p-button
        label="Speichern"
        (onClick)="this.saveTemplateVarHtmlEditor()"
      ></p-button>
    </ng-template>
  </p-dialog>
</div>
}